
























import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from '@/const';
import { Document } from '@/model/document2/document';
import { FileHelper } from '@/helper/fileHelper';
import { NameHelper } from '@/helper/nameHelper';
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class discardConfirmation extends Vue 
{
    // コールバック
    // button
    // ->
    // "discard" : 破棄して進む
    // "save" : 保存する
    @Prop() private callback! : (button : string) => void;

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }
    
    onDiscard()
    {
        DebugHelper.trace("破棄処理");

        this.callback("discard");
    }
    onSave()
    {
        DebugHelper.trace("保存処理");

        this.callback("save");
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
